import React, { useEffect } from 'react';
import { CheckCircle, XCircle, X } from 'lucide-react';

export default function Toast({ id, type = 'success', message, onClose }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose(id);
    }, 4000);

    return () => clearTimeout(timer);
  }, [id, onClose]);

  const styles = {
    success: {
      container: 'bg-white border-l-4 border-green-500',
      iconWrapper: 'bg-green-100',
      icon: <CheckCircle className="w-5 h-5 text-green-600" />,
      title: 'text-green-700 font-semibold',
      text: 'text-gray-600'
    },
    error: {
      container: 'bg-white border-l-4 border-red-500',
      iconWrapper: 'bg-red-100',
      icon: <XCircle className="w-5 h-5 text-red-600" />,
      title: 'text-red-700 font-semibold',
      text: 'text-gray-600'
    }
  };

  const style = styles[type] || styles.success;
  const title = type === 'success' ? 'Berhasil' : 'Gagal';

  return (
    <div className={`flex items-start gap-3 px-4 py-3 rounded-xl shadow-lg border border-gray-100 ${style.container} animate-slide-in-right min-w-[300px] max-w-[380px]`}>
      <div className={`flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center ${style.iconWrapper}`}>
        {style.icon}
      </div>
      <div className="flex-1 min-w-0 pt-0.5">
        <p className={`text-sm ${style.title}`}>{title}</p>
        <p className={`text-sm ${style.text} leading-snug mt-0.5`}>{message}</p>
      </div>
      <button
        onClick={() => onClose(id)}
        className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition mt-0.5"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
